// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no-margin[data-v-1bbf7377] {\n  margin: 0;\n}\n.indent[data-v-1bbf7377] {\n  padding-left: 48px;\n}\n.delete-col[data-v-1bbf7377] {\n  width: 59px;\n}\n.max-quantity-of-split-deal[data-v-1bbf7377] {\n  margin: auto;\n  width: 50%;\n  padding-left: 10px;\n}\n.product-type[data-v-1bbf7377] {\n  font-size: 12px;\n  line-height: 16px;\n  color: #4e5a6a;\n  margin-top: 6px;\n}\n", ""]);
// Exports
module.exports = exports;
